import React, { useState, useEffect, useCallback, useContext } from 'react';
import PropTypes from 'prop-types';
import { I18nContext } from 'utils/I18n/context';

const TrackParameters = ({ data, onAction }) => {
    const { t } = useContext(I18nContext);
    const [state, setState] = useState({
        name: data?.name || '',
        value: data?.value || ''
    });

    const staticNames = t?.postbackPage?.creatingEditing || { 
        trackParameters: 'Track Parameters', 
        name: 'Name', 
        value: 'Value' 
    };

    const onChange = useCallback(() => {
        onAction(state);
    }, [state, onAction]);

    useEffect(() => {
        onChange();
    }, [onChange]);

    const onChangeField = useCallback((event) => {
        const name = event.target.name;
        const value = event.target.value;

        setState(prev => ({
            ...prev,
            [name]: value
        }), () => {
            onChange();
        });
    }, [onChange]);

    return (
        <React.Fragment>
            <h4 className="bold subtitle">{staticNames.trackParameters}</h4>
            <div className="row form-group">
                <div className="form-input">
                    <input
                        className="form-control input-sm"
                        type="text"
                        name="name"
                        value={state.name}
                        placeholder={staticNames.name}
                        onChange={onChangeField}
                    />
                </div>
                <div className="form-input">
                    <input
                        className="form-control input-sm"
                        type="text"
                        name="value"
                        value={state.value}
                        placeholder={staticNames.value}
                        onChange={onChangeField}
                    />
                </div>
            </div>
        </React.Fragment>
    );
};

TrackParameters.propTypes = {
    data: PropTypes.object,
    onAction: PropTypes.func
};

TrackParameters.defaultProps = {
    data: {},
    onAction: () => {}
};

export default TrackParameters;
